// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__7o8lC","draggableHeader":"Header_draggableHeader__j52hq"};